// /*************************************************/
// /* LOTTIE ANIMATIONS                             */
// /*************************************************/
import lottie from "lottie-web";
import customEventsNames from './../customEventsNames';

export function lottieAnimation() {
    const loadingScreenSelector = '.loading-screen';
    const burgerMenuSelector = '.burger-menu';
    const assetMarketMapSelector = '.map-2024__europe';
    // Create Intersection Observer
    const observer = new IntersectionObserver(handleIntersection, { threshold: [0, 0.5, 1] });

    function handleIntersection(entries) {
        entries.forEach(entry => {
            const animation = entry.target.lottieInstance;

            if (entry.isIntersecting) {
                if (entry.target.parentElement.classList.contains('hero__lottie')) {
                    setTimeout(() => {
                        animation.play();
                    }, 1500);
                } else {
                        animation.play();
                }
            } else {
                animation.pause();
            }
        });
    }

    const init = function () {
        var lottieElements = document.querySelectorAll(".lottie");

        lottieElements.forEach(function (element) {
            var animationPath = element.getAttribute("data-lottie-json");
            var loop = true; // Default loop value
            let autoplay = false;
            let renderSettings = {};

            if (element.parentElement.classList.contains('hero__lottie')) {
                loop = false; // Set loop to false for hero__lottie elements
            }

            //Special settings for the loading screen
            const loadingScreen = element.closest(loadingScreenSelector);
            if (loadingScreen) {
                loop = false;
                renderSettings = {
                    preserveAspectRatio: 'xMidYMax slice' //Kinda like object-fit
                }
            }

            var assetMarketMap = element.closest(assetMarketMapSelector);
            if (assetMarketMap) {
                loop = false;
                autoplay = false
            }

            const burgerMenu = element.closest(burgerMenuSelector);
            if (burgerMenu) {
                loop = true;
                autoplay = false;
            }

            // Load animation
            var animation = lottie.loadAnimation({
                container: element,
                renderer: 'svg',
                loop: loop,
                autoplay: autoplay,
                path: animationPath,
                rendererSettings: renderSettings,
            });

            element.lottieInstance = animation;

            if (burgerMenu) {
                burgerMenu.addEventListener('mouseenter', e => {
                    animation.loop = true;
                    animation.play();
                });

                burgerMenu.addEventListener('mouseleave', e => {
                    animation.loop = false;
                });
            } else if (assetMarketMap) {
                assetMarketMap.addEventListener(customEventsNames.assetMarketMapVisible, e => {
                    animation.goToAndPlay(0, true);
                });

                assetMarketMap.addEventListener(customEventsNames.assetMarketMapHidden, e => {
                    animation.goToAndStop(0, true);
                });
            } else if (loadingScreen) {
                //When the animation is ready, change the classes manipulating the body
                animation.addEventListener("DOMLoaded", e => {
                    document.body.classList.remove('is-loading-loadingscreen');
                    loadingScreen.classList.add('loading-screen--loaded');
                });

                //When the animation is done, remove the class that restricts the body
                animation.addEventListener("complete", e => {
                    document.body.classList.remove('is-playing-loadingscreen');
                    animation.destroy();
                });

                animation.play();
            }
            else {
                // Observe the element
                observer.observe(element);
            }
        });
    };

    init();
}
